import { FormType } from "@bankingright-dashboard/enums";
import { AccountAccessForm } from "./form";

export const AccountAccessEdit= () => {
    return (
        <AccountAccessForm type={FormType.edit} />
    );
};